import { render, staticRenderFns } from "./StoreCategoryButton.vue?vue&type=template&id=5ace1981&"
import script from "./StoreCategoryButton.vue?vue&type=script&lang=js&"
export * from "./StoreCategoryButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports